<div id="list-groups">
  <div class="list-groups-header" data-cy="list-groups-header-section">
    <ion-button
      id="list-groups-header-all-groups-button"
      data-cy="list-groups-header-all-groups-button"
      [ngClass]="
        !selectedGroup ? 'usf-fill-green-button' : 'usf-outline-green-button'
      "
      (click)="onShowAllGroups('list-groups-header-all-groups-button')"
    >
      {{ 'i18n.lists.allGroups' | translate }}
    </ion-button>
    <ion-button
      *ngIf="groups?.length === 0"
      data-cy="list-groups-header-unassigned-group-button"
      class="usf-fill-disabled-button"
    >
      {{ 'i18n.lists.unassignedGroup' | translate }}
    </ion-button>
    <ion-button
      *ngFor="let group of groups; let i = index"
      id="{{
        group?.groupName !== 'Unassigned Group'
          ? 'list-groups-header-button-' + i
          : 'list-groups-unassigned-button'
      }}"
      [attr.data-cy]="'list-groups-header-button-' + i"
      [ngClass]="
        selectedGroup && group?.groupName === selectedGroup
          ? 'usf-fill-green-button'
          : 'usf-outline-green-button'
      "
      [item]="group"
      (click)="changeSelectedGroup(group, 'list-groups-header-button-' + i)"
      lmaDragDropItem
    >
      {{ group?.groupName }}
    </ion-button>
  </div>

  <!-- Needed for list management adding search bar -->
  <ng-content></ng-content>

  <div
    *ngIf="!selectedGroup"
    data-cy="list-groups-section"
    class="list-groups-container"
    cdkDropList
  >
    <button
      *ngFor="let group of groups; let i = index"
      id="list-groups-button-{{ i }}"
      [attr.data-cy]="'list-groups-button-' + i"
      class="list-groups-button"
      [item]="group"
      (click)="changeSelectedGroup(group, 'list-groups-header-button-' + i)"
      (cdkDragDropped)="onDragDropped($event)"
      cdkDrag
      lmaDragDropItem
    >
      <div
        [attr.data-cy]="'list-groups-button-section-' + i"
        class="button-content"
      >
        <span [attr.data-cy]="'list-groups-button-group-name-text-' + i">
          {{ group?.groupName }}&nbsp;
        </span>
        <p [attr.data-cy]="'list-groups-button-num-products-text-' + i">
          ({{ group?.itemCount || 0 }})
        </p>
        <ion-icon
          [attr.data-cy]="'list-groups-button-drag-drop-icon-' + i"
          cdkDragHandle
          name="menu-outline"
        ></ion-icon>
      </div>
    </button>
  </div>

  <div
    *ngIf="groups?.length === 0"
    data-cy="list-groups-unassigned-group-section"
    class="list-groups-container"
  >
    <button
      data-cy="list-groups-unassigned-group-button"
      class="list-groups-button"
      mode="ios"
      [disabled]="true"
    >
      <div
        data-cy="list-groups-unassigned-group-button-section"
        class="button-content"
      >
        <span data-cy="list-groups-unassigned-group-text">
          {{ 'i18n.lists.unassignedGroup' | translate }}&nbsp;(0)
        </span>
        <ion-icon
          data-cy="list-groups-unassigned-group-icon"
          name="menu-outline"
        ></ion-icon>
      </div>
    </button>
  </div>
</div>
